import React from 'react';
import { 
  Button as MuiButton, 
  ButtonProps as MuiButtonProps,
  CircularProgress
} from '@mui/material';

export interface ButtonProps extends Omit<MuiButtonProps, 'startIcon'> {
  loading?: boolean;
  startIcon?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  disabled, 
  loading = false, 
  startIcon, 
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  ...props 
}) => {
  return (
    <MuiButton
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      startIcon={loading ? undefined : startIcon}
      {...props}
    >
      {loading && (
        <CircularProgress
          size={24}
          thickness={4}
          sx={{
            color: 'inherit',
            position: 'absolute',
            left: '50%',
            marginLeft: '-12px',
          }}
        />
      )}
      <span style={{ visibility: loading ? 'hidden' : 'visible' }}>
        {children}
      </span>
    </MuiButton>
  );
};

export default Button;